// AIDEV-NOTE: Abstracao sobre navigator.geolocation para facilitar mocks em testes

export interface GeoPosition {
  lat: number;
  lng: number;
  accuracy: number;
  timestamp: number;
}

export interface GeoError {
  code: number;
  message: string;
}

const defaultOptions: PositionOptions = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 5000
};

export const geolocationService = {
  isSupported: () => 'geolocation' in navigator,

  getCurrentPosition(): Promise<GeoPosition> {
    return new Promise((resolve, reject) => {
      if (!geolocationService.isSupported()) {
        reject({ code: 0, message: 'Geolocalizacao nao suportada neste dispositivo' } as GeoError);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
            timestamp: pos.timestamp
          }),
        (err) => reject({ code: err.code, message: err.message } as GeoError),
        defaultOptions
      );
    });
  },

  watchPosition(onSuccess: (pos: GeoPosition) => void, onError: (err: GeoError) => void): number {
    if (!geolocationService.isSupported()) {
      onError({ code: 0, message: 'Geolocalizacao nao suportada' });
      return -1;
    }
    return navigator.geolocation.watchPosition(
      (pos) =>
        onSuccess({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          timestamp: pos.timestamp
        }),
      (err) => onError({ code: err.code, message: err.message }),
      defaultOptions
    );
  },

  clearWatch(id: number) {
    if (id >= 0) navigator.geolocation.clearWatch(id);
  }
};
